import { Box, Stack } from '@mui/material';
import styled from 'styled-components';

export const StepsContainer = styled(Stack)`
  && {
    position: relative;
    display: flex;
    align-items: center;
  }
`;

export const StepConnectorWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.25rem;
  flex-shrink: 0;
`;

export const StepConnector = styled(Box)`
  height: 2px;
  width: calc(100% - 6px);
  background-color: ${({ theme }) => theme.palette.stroke.primary};
  flex-shrink: 0;
`;
